import type { FC } from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { AnnieFeedbackReason } from "../../utils/annieStream";
import { type SystemChipItem, SystemChips } from "../UIToolkit/Clickable/TabsAndChips/SystemChips/SystemChips";

const REASONS: AnnieFeedbackReason[] = ["incorrect", "missing_capability", "confusing", "other"];

type Props = {
	conversationId: number;
	value: AnnieFeedbackReason | null;
	disabled: boolean;
	onChange: (reason: AnnieFeedbackReason | null) => void;
};

export const AnnieFeedbackReasonSelector: FC<Props> = ({ conversationId, value, disabled, onChange }) => {
	const { t } = useTranslation();
	const items = useMemo<SystemChipItem<AnnieFeedbackReason>[]>(
		() =>
			REASONS.map((reason) => ({
				value: reason,
				label: t(`annie.feedback.reason.${reason}`),
				disabled,
			})),
		[t, disabled],
	);
	return (
		<SystemChips
			items={items}
			selectedItems={items.filter((item) => item.value === value)}
			forceFitContent
			touchTarget
			rootSx={{ justifyContent: "flex-start" }}
			onChange={(item, selected) => onChange(selected ? item.value : null)}
			dataTestId={`annie-feedback-reasons-${conversationId}`}
			getItemDataTestId={(item) => `annie-feedback-reason-${item.value}-${conversationId}`}
		/>
	);
};
